const SetupUsersOrderNotSelectedActionTypes = {
  GET_ORDER_NOT_SELECTED_START: 'GET_ORDER_NOT_SELECTED_START',
  GET_ORDER_NOT_SELECTED_SUCCESS: 'GET_ORDER_NOT_SELECTED_SUCCESS',
  GET_ORDER_NOT_SELECTED_FAILURE: 'GET_ORDER_NOT_SELECTED_FAILURE',
  UPDATE_ORDER_NOT_SELECTED: 'UPDATE_ORDER_NOT_SELECTED',
};

export default SetupUsersOrderNotSelectedActionTypes;
